"use strict";

Shopify.theme.jsFaqSection = {
  init: function init($section) {
    Shopify.theme.jsFaqSection = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
    this.$section = $section

    let $panel = $section.find('.faq__item')
    let $questions = $section.find('.faq__item-question')

    let $wrapper = $section.find('[data-faqs]')
    let $tags = $section.find('[data-tags] [data-tag]')


    $tags.on('click', function (e) {
      e.preventDefault()
      $tags.removeClass('is-active')
      $(this).addClass('is-active')
      let tag = $(this).data('tag')
      console.log(tag)
      $wrapper.find('[data-tag]').hide()
      $wrapper.find(`[data-tag=${tag}]`).show()
    })


    $questions.on('click', function () {
      if ($(this).siblings('.faq__item-answer').css('display') == 'none') {
        $(this).parent().addClass('tab--open')
        $(this).siblings('.faq__item-answer').slideDown()
      } else {
        $(this).siblings('.faq__item-answer').slideUp(() => {
          $(this).parent().removeClass('tab--open')
        })
      }
    })
  },
  unload: function unload($section) {
    let $panel = $section.find('.faq__item')
    let $questions = $section.find('.faq__item-question')
    let $tags = $section.find('[data-tags] [data-tag]')
    $questions.off('click');
    $heading.off('click')
    $tags.off('click')
  }
};